import { css } from '@emotion/react'
import { colors } from 'utils/colors'

export type ProgressBarProps = {
  /**
   * Number from 0 to 1, 0 means 0 %, 1 means 100 %, 0.35 means 35 %.
   */
  progress: number
  height?: number
}

export function ProgressBar(props: ProgressBarProps) {
  return (
    <div
      css={css`
        --progress-bar-height: ${props.height ?? 2}px;
        position: relative;
        width: 100%;
        height: var(--progress-bar-height);
        border-radius: var(--progress-bar-height);
        background: ${colors.blue[100]};
        overflow: hidden;
      `}
    >
      <div
        css={css`
          position: absolute;
          top: 0;
          left: 0;
          width: ${props.progress * 100}%;
          transition: width 0.8s ease-out;
          height: var(--progress-bar-height);
          border-radius: var(--progress-bar-height);
          background: ${colors.blue[500]};
        `}
      />
    </div>
  )
}
